import { defineStore } from 'pinia'

export type Theme = 'light' | 'dark' | 'ai'
export type Density = 'cozy' | 'compact'
export type Role = 'Engineer' | 'Lead' | 'Manager' | 'Admin'
export type HomeVariant = 'loop' | 'focus' | 'ops'
export type RadarVariant = 'focus' | 'classic' | 'business'

interface AppState {
  theme: Theme
  density: Density
  role: Role
  homeVariant: HomeVariant
  radarVariant: RadarVariant
  currentTeamId: string
  currentTeamSlug: string
  editModeActive: boolean
  /** AI-only shell — always true (legacy toggle is a no-op). */
  aiMode: boolean
  /** Narrow icon rail; persisted for layout grid on first paint */
  sidebarCollapsed: boolean
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    theme: 'light',
    density: 'cozy',
    role: 'Lead',
    homeVariant: 'loop',
    radarVariant: 'focus',
    currentTeamId:
      localStorage.getItem('teamofone.currentTeamId') ||
      localStorage.getItem('hl.teamId') ||
      '',
    currentTeamSlug:
      localStorage.getItem('teamofone.currentTeamSlug') ||
      localStorage.getItem('teamofone.currentTeamId') ||
      localStorage.getItem('hl.teamId') ||
      '',
    editModeActive: false,
    aiMode: true,
    sidebarCollapsed: localStorage.getItem('hl_sidebar_collapsed') === '1',
  }),
  actions: {
    setTheme(theme: Theme) {
      this.theme = theme
    },
    setDensity(density: Density) {
      this.density = density
    },
    setRole(role: Role) {
      this.role = role
    },
    setHomeVariant(variant: HomeVariant) {
      this.homeVariant = variant
    },
    setRadarVariant(variant: RadarVariant) {
      this.radarVariant = variant
    },
    switchTeam(id: string, slug = id) {
      this.currentTeamId = id
      this.currentTeamSlug = slug
      localStorage.setItem('teamofone.currentTeamId', id)
      localStorage.setItem('teamofone.currentTeamSlug', slug)
      localStorage.setItem('hl.teamId', id)
      localStorage.setItem('teamofone.devLocationId', id)
    },
    setCurrentTeamSlug(slug: string) {
      this.currentTeamSlug = slug
      localStorage.setItem('teamofone.currentTeamSlug', slug)
    },
    setEditMode(active: boolean) {
      this.editModeActive = active
    },
    toggleAiMode() {
      this.aiMode = true
      localStorage.setItem('hl.aiMode', '1')
    },
    toggleSidebarCollapsed() {
      this.sidebarCollapsed = !this.sidebarCollapsed
      localStorage.setItem(
        'hl_sidebar_collapsed',
        this.sidebarCollapsed ? '1' : '0',
      )
    },
  },
})
